import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'countDown',
})
export class CountDownPipe implements PipeTransform {
    transform(value: number, format: 'mm:ss' | 'ss' | 'mm' | 'm'): string {
        const minutes: number = Math.floor(value / 60);
        const seconds = value - minutes * 60;
        switch (format) {
            case 'ss':
                return this.pad(seconds);
            case 'mm':
                return this.pad(minutes);
            case 'm':
                return minutes.toString();
            default:
                return `${this.pad(minutes)}:${this.pad(seconds)}`;
        }
    }

    pad(num: number): string {
        return `00${num}`.slice(-2);
    }
}
